import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PhotoBand = () => {
  const { language } = useLanguage();
  const sl = language === 'sl';

  return (
    <div className="relative h-[400px] lg:h-[640px] overflow-hidden bg-[#0E1114]" data-testid="photo-band">
      <picture>
        <source srcSet="/images/exterior.webp" type="image/webp" />
        <img 
          src="/images/exterior.jpg" 
          alt={sl ? 'Poslovni center General Ledger, Celjska cesta 47, Rogatec' : 'General Ledger Business Center, Celjska cesta 47, Rogatec'}
          className="w-full h-full object-cover object-[center_60%]"
          loading="lazy"
        />
      </picture>
      <div className="absolute left-4 lg:left-[120px] bottom-8 lg:bottom-14 bg-[#0E1114] text-[#F4EFE6] p-6 lg:p-8 max-w-[520px] border-l-[3px] border-[#C9A462]">
        <span className="text-[12px] font-bold tracking-[2.5px] text-[#C9A462] block mb-2">
          BUSINESS CENTER GENERAL LEDGER
        </span>
        <span className="font-serif text-[24px] lg:text-[38px] leading-[1.08] block">
          {sl ? (
            <>Prava pisarna, pravi ljudje — <span className="italic text-[#C9A462]">od leta 2003.</span></>
          ) : (
            <>Real office, real people — <span className="italic text-[#C9A462]">since 2003.</span></>
          )}
        </span>
        <span className="text-[15px] text-[#C9C3B7] block mt-2.5">
          Celjska cesta 47, Rogatec · {sl ? 'brezplačno parkirišče pred vrati' : 'free parking at the door'}
        </span>
      </div>
    </div>
  );
};

export default PhotoBand;
